import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './state/AuthContext.jsx';
import { NoticeProvider } from './state/NoticeContext.jsx';
import { ThemeProvider } from './state/ThemeContext.jsx';
import './theme.css';
import './app.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <NoticeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </NoticeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
